export default __webpack_public_path__ + "static/media/ghanabag.049b4656.png";